import { render, staticRenderFns } from "./campaign-initiated-calls.vue?vue&type=template&id=249b0270"
import script from "./campaign-initiated-calls.vue?vue&type=script&lang=js"
export * from "./campaign-initiated-calls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports